export default function formatDate(value, format) {
	//let curDate = new Date(value);
	let curDate = new Date(value);
	const o = {
		'M+': curDate.getMonth() + 1, // 月份
		'd+': curDate.getDate(), // 日
		'h+': curDate.getHours(), // 小时
		'm+': curDate.getMinutes(), // 分
		's+': curDate.getSeconds(), // 秒
		'q+': Math.floor((curDate.getMonth() + 3) / 3), // 季度
		'S': curDate.getMilliseconds() // 毫秒
	};
	if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (curDate.getFullYear() + '').substr(4 - RegExp.$1.length));
	for (let k in o) {
		if (new RegExp('(' + k + ')').test(format)) format = format.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
	}
	return format;
};
//时间格式化（HH:mm:ss）
export function formatHh(timestamp) {
	var date = new Date(timestamp);
	var year = date.getFullYear();
	var month = addZero(date.getMonth() + 1);
	var day = addZero(date.getDate());
	var hours = addZero(date.getHours());
	var minutes = addZero(date.getMinutes());
	var seconds = addZero(date.getSeconds());
	return hours + ':' + minutes + ':' + seconds;
	// return year + '-' + month + '-' + day;
}
function addZero(num) {
	return num < 10 ? '0' + num : num;
}